import { BrowserRouter } from 'react-router-dom';

import AppRouter from './router';

// TSS vite/01 — app shell. Wires the router and layout chrome.
// No Auth/QueryClient layers: the site is public and has no backend.
export default function App() {
    return (
        <BrowserRouter>
            <AppRouter />
        </BrowserRouter>
    );
}
